'use client';

import { useState, type ReactNode } from 'react';
import posthog from 'posthog-js';
import { redirectToCheckout } from '@/lib/subscription/utils';

interface UpgradeCtaProps {
  context: string;
  className?: string;
  variant?: 'card' | 'inline';
  children?: ReactNode;
}

export function UpgradeCta({ context, className, variant = 'card', children }: UpgradeCtaProps) {
  const [loading, setLoading] = useState(false);

  const handleUpgrade = async () => {
    setLoading(true);
    posthog.capture('upgrade_cta_clicked', { context });
    try {
      await redirectToCheckout();
    } finally {
      setLoading(false);
    }
  };

  if (variant === 'inline') {
    return (
      <button
        onClick={handleUpgrade}
        disabled={loading}
        className={className ?? 'text-sm font-medium text-[var(--accent-blue)] hover:underline disabled:opacity-50'}
      >
        {loading ? 'Redirecting...' : (children ?? 'Upgrade \u2014 $15/month')}
      </button>
    );
  }

  return (
    <div className={className ?? 'rounded-lg border border-[var(--accent-blue)]/20 bg-[var(--accent-blue)]/5 p-6'}>
      <h3 className="text-lg font-semibold text-[var(--text-primary)]">
        Upgrade to Plus
      </h3>
      <p className="mt-1 text-sm text-[var(--text-secondary)]">
        Get 200 AI questions/month, all premium models, web search, thinking mode, and unlimited documents.
      </p>
      <button
        onClick={handleUpgrade}
        disabled={loading}
        className="mt-4 rounded-md bg-[var(--accent-blue)] px-4 py-2 text-sm font-medium text-white transition-opacity hover:opacity-90 disabled:opacity-50"
      >
        {loading ? 'Redirecting...' : 'Upgrade \u2014 $15/month'}
      </button>
    </div>
  );
}
